
import React from 'react';
import type { TravelPackage } from './PackagesSection';
import { getExperienceImageUrl } from '@/environments/environment';

interface PackageCardProps {
  package: TravelPackage;
  onAddToCart: () => void;
}

export const PackageCard: React.FC<PackageCardProps> = ({ package: pkg, onAddToCart }) => {
  const imageSrc = getExperienceImageUrl(pkg.image);

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group flex flex-col h-full">
      <div className="relative overflow-hidden">
        <img
          src={imageSrc}
          alt={pkg.title}
          className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-3 left-3">
          <span className="bg-emerald-600 text-white px-3 py-1 rounded-full text-sm font-medium">
            {pkg.category}
          </span>
        </div>
        <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm rounded-lg px-2 py-1">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-yellow-400 text-sm"></i>
            <span className="text-sm font-medium text-gray-900">{pkg.rating}</span>
          </div>
        </div>
      </div>

      <div className="p-6 flex flex-col flex-1">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">
            {pkg.title}
          </h3>
          <div className="flex items-center gap-4 text-sm text-gray-600 mb-2">
            <div className="flex items-center gap-1">
              <i className="ri-map-pin-line"></i>
              <span>{pkg.location}</span>
            </div>
            <div className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              <span>{pkg.duration}</span>
            </div>
          </div>
          <p className="text-gray-600 text-sm line-clamp-2 mb-3">
            {pkg.description}
          </p>
        </div>

        <div className="mt-auto">
          <div className="flex items-center justify-between mb-4">
            <div>
              <div className="text-2xl font-bold text-emerald-600">
                ₹{pkg.price.toLocaleString()}
              </div>
              <div className="text-sm text-gray-500">
                {pkg.reviews} reviews
              </div>
            </div>
            <div className="flex items-center gap-1 text-sm text-gray-600">
              <i className="ri-star-fill text-yellow-400"></i>
              <span>{pkg.rating}</span>
              <span>({pkg.reviews})</span>
            </div>
          </div>

          <button
            onClick={onAddToCart}
            className="w-full bg-emerald-600 text-white py-3 rounded-lg hover:bg-emerald-700 transition-colors duration-200 font-medium flex items-center justify-center gap-2 whitespace-nowrap"
          >
            <i className="ri-shopping-cart-line"></i>
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};
